export default "__VITE_ASSET__CHVECpR$__"